import { render, staticRenderFns } from "./ItemFilterItemAddFilter.vue?vue&type=template&id=f613266c&scoped=true"
import script from "./ItemFilterItemAddFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterItemAddFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f613266c",
  null
  
)

export default component.exports